const CAT_LBS = '-LBS';
const AGC_AGT_AD_ERECRUIT = '-(AGT|AD)';
const CAT_ERECRUITMENT = '-EREC';
const CAT_EPROMOTION = '-ESUB';

const AGNT_CHNL = 'AGNT_CHNL';
const FTA_CHNL = 'FTA_CHNL';

const FTA_RECRUITER = 'FTA_CHNL-AGT-EREC-RECRUITER';
const FTA_AD_DIRECTOR = 'FTA_CHNL-AD-EREC-AD';
const FTA_AGT_DIRECTOR = 'FTA_CHNL-AGT-EREC-AD';
const FTA_AGT_OPERATION_SERVICE = 'FTA_CHNL-AGT-EREC-AOS';
const FTA_AGT_MANAGER = 'FTA_CHNL-AGT-EREC-AM';

const AGNT_RECRUITER = 'AGNT_CHNL-AGT-EREC-RECRUITER';
const AGNT_AD_DIRECTOR = 'AGNT_CHNL-AD-EREC-AD';
const AGNT_AGT_DIRECTOR = 'AGNT_CHNL-AGT-EREC-AD';
const AGNT_AGT_OPERATION_SERVICE = 'AGNT_CHNL-AGT-EREC-AOS';
const AGNT_AGT_MANAGER = 'AGNT_CHNL-AGT-EREC-AM';

export const AGC_CHNL = 'AGNT_CHNL';
export const NOUS_CHNL = 'FTA_CHNL';
export const ACB_CHNL = 'ACB_CHNL';
export const TPB_CHNL = 'TURNP_CHNL';
export const DELASOL_CHNL = 'BRT_CHNL';

const CAT_ESUB = '-ESUB';
export const AGENCY_NOUS = 'agencyNous';
export const AGENCY = 'agency';
export const NOUS = 'nous';
export const DLS = 'dls';
export const PS = 'ps';
export const ACB = 'acb';
export const TPB = 'tpb';

export const RoleConstants = {
  AGNT_CHNL: 'AGNT_CHNL',
  FTA_CHNL: 'FTA_CHNL',
  BRT_CHNL: 'BRT_CHNL',
  TURNP_CHNL: 'TURNP_CHNL',
  ACB_CHNL: 'ACB_CHNL',
  CAT_LBS,
  PHANC_CHNL: 'PHANC_CHNL',
  SAMO_CHNL: 'SAMO_CHNL',
  CCJ_CHNL: 'CCJ_CHNL',
  TCA_CHNL: 'TCA_CHNL',
  QLA_CHNL: 'QLA_CHNL',
  MED_CHNL: 'MED_CHNL',
  MARS_CHNL: 'MARS_CHNL',
  ANY: '*',
  GUEST: 'GUEST',
  // Agency - E-recruitment Channel
  AGC_AGT_ERE_RECRUITER:
    AGC_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-RECRUITER',
  AGC_AGT_ERE_AM: AGC_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AM',
  AGC_AGT_ERE_AD: AGC_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AD',
  AGC_AGT_ERE_AOS: AGC_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AOS',

  // NOUS - E-recruitment Channel
  NOUS_AGT_ERE_RECRUITER:
    NOUS_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-RECRUITER',
  NOUS_AGT_ERE_AM: NOUS_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AM',
  NOUS_AGT_ERE_AD: NOUS_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AD',
  NOUS_AGT_ERE_AOS: NOUS_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AOS',
  FTA_AD: NOUS_CHNL + '-(AD-FA-MGR|AD-AD-MGR)',

  // FLAIR - E-recruitment Channel
  ACB_AGT_ERE_RECRUITER:
    ACB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-RECRUITER',
  ACB_AGT_ERE_RECRUITER_REFERRAL:
    ACB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-REFERRAL',
  ACB_AGT_ERE_AD: ACB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AD',
  ACB_AGT_ERE_AOS: ACB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AOS',

  TPB_CHNL,
  TPB_AGT_ERE_RECRUITER:
    TPB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-RECRUITER',
  TPB_AGT_ERE_RECRUITER_REFERRAL:
    TPB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-REFERRAL',
  TPB_AGT_ERE_AD: TPB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AD',
  TPB_AGT_ERE_AOS: TPB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AOS',

  // DELASOL - E-recruitment Channel
  BRT_AGT_ERE_RECRUITER:
    DELASOL_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-RECRUITER',
  BRT_AGT_ERE_APPROVAL_1:
    DELASOL_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-APP-1',
  BRT_AGT_ERE_APPROVAL_2:
    DELASOL_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-APP-2',
  BRT_AGT_ERE_AOS:
    DELASOL_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AOS',

  // Agency - E-Promotion Channel
  AGC_AGT_EPRO_CREATOR:
    AGC_CHNL + AGC_AGT_AD_ERECRUIT + CAT_EPROMOTION + '-RECRUITER',
  AGC_AGT_EPRO_AD: AGC_CHNL + AGC_AGT_AD_ERECRUIT + CAT_EPROMOTION + '-AD',
  AGC_AGT_EPRO_AOS: AGC_CHNL + AGC_AGT_AD_ERECRUIT + CAT_EPROMOTION + '-AOS',
  AGC_AGT_EPRO_AOS_HEAD:
    AGC_CHNL + AGC_AGT_AD_ERECRUIT + CAT_EPROMOTION + '-HEAD-AOS',

  AGC_AGT_AD_ERECRUIT_RECRUITER:
    AGNT_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-RECRUITER',
  AGC_AGT_AD_ERECRUIT_AM:
    AGNT_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AM',
  AGC_AGT_AD_ERECRUIT_AD:
    AGNT_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AD',
  AGC_AGT_AD_ERECRUIT_AOS:
    AGNT_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AOS',
  FTA_AGT_AD_ERECRUIT_RECRUITER:
    FTA_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-RECRUITER',
  FTA_AGT_AD_ERECRUIT_AM:
    FTA_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AM',
  FTA_AGT_AD_ERECRUIT_AD:
    FTA_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AD',
  FTA_AGT_AD_ERECRUIT_AOS:
    FTA_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-AOS',
  AGC_AGT_AD_ESUB_RECRUITER:
    AGNT_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ESUB + '-RECRUITER',
  AGC_AGT_AD_ESUB_AD: AGNT_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ESUB + '-AD',
  AGC_AGT_AD_ESUB_AOS: AGNT_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ESUB + '-AOS',
  AGC_AGT_AD_ESUB_AOS_HEAD:
    AGNT_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ESUB + '-HEAD-AOS',
};

export const E_RECRUITMENT = [
  AGNT_RECRUITER,
  AGNT_AD_DIRECTOR,
  AGNT_AGT_DIRECTOR,
  AGNT_AGT_OPERATION_SERVICE,
  AGNT_AGT_MANAGER,

  FTA_RECRUITER,
  FTA_AGT_MANAGER,
  FTA_AGT_DIRECTOR,
  FTA_AD_DIRECTOR,
  FTA_AGT_OPERATION_SERVICE,

  ACB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT,
  TPB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT,
  DELASOL_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT,
];

export const E_RECRUITMENT_AOS = [
  AGNT_AGT_OPERATION_SERVICE,
  FTA_AGT_OPERATION_SERVICE,
  RoleConstants.BRT_AGT_ERE_AOS,
];
export const E_RECRUITMENT_RECRRUITER = [AGNT_RECRUITER, FTA_RECRUITER];
export const E_RECRUITMENT_AM = [AGNT_AGT_MANAGER, FTA_AGT_MANAGER];

export const E_RECRUITMENT_ANOTHER_AD_AOS = [
  'AGNT_CHNL-AGT-EREC-RECRUITER',
  'AGNT_CHNL-AGT-EREC-AM',
  AGNT_AGT_OPERATION_SERVICE,
  FTA_AGT_OPERATION_SERVICE,
  RoleConstants.ACB_AGT_ERE_RECRUITER,
  RoleConstants.ACB_AGT_ERE_AD,
  RoleConstants.ACB_AGT_ERE_AOS,
  RoleConstants.TPB_AGT_ERE_RECRUITER,
  RoleConstants.TPB_AGT_ERE_AD,
  RoleConstants.TPB_AGT_ERE_AOS,
  RoleConstants.BRT_AGT_ERE_RECRUITER,
  RoleConstants.BRT_AGT_ERE_APPROVAL_1,
  RoleConstants.BRT_AGT_ERE_APPROVAL_2,
  RoleConstants.BRT_AGT_ERE_AOS,
];

export const E_RECRUITMENT_AD = [
  'AGNT_CHNL-AD-EREC-AD',
  'AGNT_CHNL-AD-AD-MGR',
  RoleConstants.FTA_AD,
];

export const AGENCY_E_RECRUITMENT = [
  AGNT_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT,
];

export const NOUS_E_RECRUITMENT_AD = [RoleConstants.FTA_AD];

export const NOUS_E_RECRUITMENT = [
  FTA_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT,
];

export const AGENCY_AND_NOUS_E_RECRUITMENT_RECRUITER = [
  RoleConstants.AGC_AGT_ERE_RECRUITER,
  RoleConstants.NOUS_AGT_ERE_RECRUITER,
];

export const AGENCY_AND_NOUS_E_RECRUITMENT_AM = [
  RoleConstants.AGC_AGT_ERE_AM,
  RoleConstants.NOUS_AGT_ERE_AM,
];

export const AGENCY_AND_NOUS_E_RECRUITMENT_AD = [
  RoleConstants.AGC_AGT_ERE_AD,
  RoleConstants.NOUS_AGT_ERE_AD,
];

export const AGENCY_AND_NOUS_E_RECRUITMENT_AOS = [
  RoleConstants.AGC_AGT_ERE_AOS,
  RoleConstants.NOUS_AGT_ERE_AOS,
];

export const FLAIR_E_RECRUITMENT = [
  ACB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT,
  TPB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT,
  ACB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-LBS',
  TPB_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT + '-LBS',
];

export const DELASOL_E_RECRUITMENT = [
  DELASOL_CHNL + AGC_AGT_AD_ERECRUIT + CAT_ERECRUITMENT,
];

export const FLAIR_E_RECRUITMENT_RECRUITER = [
  RoleConstants.ACB_AGT_ERE_RECRUITER,
  RoleConstants.TPB_AGT_ERE_RECRUITER,
];

export const FLAIR_E_RECRUITMENT_RECRUITER_REFERRAL = [
  RoleConstants.ACB_AGT_ERE_RECRUITER_REFERRAL,
  RoleConstants.TPB_AGT_ERE_RECRUITER_REFERRAL,
];

export const FLAIR_E_RECRUITMENT_AD = [
  RoleConstants.ACB_AGT_ERE_AD,
  RoleConstants.TPB_AGT_ERE_AD,
];

export const FLAIR_E_RECRUITMENT_AOS = [
  RoleConstants.ACB_AGT_ERE_AOS,
  RoleConstants.TPB_AGT_ERE_AOS,
];

export const DELASOL_E_RECRUITMENT_RECRUITER = [
  RoleConstants.BRT_AGT_ERE_RECRUITER,
];

export const AGENCY_E_PROMOTION = [
  AGNT_CHNL + AGC_AGT_AD_ERECRUIT + CAT_EPROMOTION,
];

export const E_RECRUITMENT_ALL_ROLE_AGENCY_AND_NOUS = [
  RoleConstants.AGC_AGT_AD_ERECRUIT_RECRUITER,
  RoleConstants.AGC_AGT_AD_ERECRUIT_AM,
  RoleConstants.AGC_AGT_AD_ERECRUIT_AD,
  RoleConstants.AGC_AGT_AD_ERECRUIT_AOS,
  RoleConstants.FTA_AGT_AD_ERECRUIT_RECRUITER,
  RoleConstants.FTA_AGT_AD_ERECRUIT_AM,
  RoleConstants.FTA_AGT_AD_ERECRUIT_AD,
  RoleConstants.FTA_AGT_AD_ERECRUIT_AOS,
];

export const E_SUB_ALL_ROLE_AGENCY = [
  RoleConstants.AGC_AGT_AD_ESUB_RECRUITER,
  RoleConstants.AGC_AGT_AD_ESUB_AD,
  RoleConstants.AGC_AGT_AD_ESUB_AOS,
  RoleConstants.AGC_AGT_AD_ESUB_AOS_HEAD,
];

export const E_RECRUITMENT_ALL_ROLE_DLS = [
  RoleConstants.BRT_AGT_ERE_RECRUITER,
  RoleConstants.BRT_AGT_ERE_APPROVAL_1,
  RoleConstants.BRT_AGT_ERE_APPROVAL_2,
  RoleConstants.BRT_AGT_ERE_AOS,
];
